export default "__VITE_ASSET__BC3yYZ97__"